import { Spin, Table } from 'antd';
import { calculateColumnsWidth } from 'api/common';

import { BankMasterFormPayloadType } from 'api/nach';
import { useEffect, useState } from 'react';
import { BankMasterColumnsFields } from './BankMasterColumnsFields';

type Props = {
  filter: any;
  onSubmit: (values: any) => Promise<void>;
  data?: any;
};

const BankMasterTables = ({ filter, data }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading] = useState(false);
  const [_isRetry] = useState(false);
  const [bankDetailsData, setBankDetailsData] = useState<BankMasterFormPayloadType[]>([]);

  useEffect(() => {
    setIsLoading(true);
    setBankDetailsData(data);
  }, [data]);

  useEffect(() => {
    console.log(filter);
    console.log(isLoading);
  }, [filter]);

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    setIsLoading(false);

    if (sorter.hasOwnProperty('column')) {
    }
  };

  const maxWidthPerCell = 1000;

  const dataTable = calculateColumnsWidth(
    BankMasterColumnsFields,
    bankDetailsData,
    maxWidthPerCell
  );
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      <Spin spinning={isModalLoading}>
        <Table
          columns={dataTable.columns}
          dataSource={dataTable.source}
          rowKey={rowKey}
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          pagination={false}
          onChange={handleChange}
        />
      </Spin>
    </>
  );
};

export default BankMasterTables;
